/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Training } from '../../models/training';

export interface ApiMasterTrainingGetActiveGet$Params {
}

export function apiMasterTrainingGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterTrainingGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Training>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrainingGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Training>>;
    })
  );
}

apiMasterTrainingGetActiveGet.PATH = '/api/Master/Training/GetActive';
